import React, { useCallback, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import _ from 'lodash'

import showToastNotification from './../../widgets/toastify'
import CustomCheckOrRadio from '../../widgets/custom_check'
import CustomDropdown from '../../widgets/custom_dropdown'
import { ApiHelper } from '../../../helpers/apihelper'
import { useSelector } from 'react-redux'

import * as Constants from './../../../helpers/constants'
import * as MiscellaneousConstants from './../helpers/constants'


const RADAR_ACTIONS = MiscellaneousConstants.RADAR_ACTIONS

const initialState = {
  status: false,
  allow_purchase_without_subscription: false,
  payment_initiated: _.find(RADAR_ACTIONS, { value: 'soft_block_user' }),
  redzone_countries_payment_initiated: _.find(RADAR_ACTIONS, { value: 'contact_support' }),
  payment_failed: _.find(RADAR_ACTIONS, { value: 'soft_block_user' })
}

const RadarSettings = ({ client }) => {
  const [state, setState] = useState(initialState)
  const crmUser = useSelector(state => state.user);

  const getRadarSettings = useCallback(() => {
    const requestQueryParams = {
      key: 'all',
      client_secret: Constants.CLIENT_SECRET,
      crm_user_details: JSON.stringify({ name: crmUser.name, user_id: crmUser.id }),
    }

    const queryParams = _.pick(requestQueryParams, ApiHelper(client, 'GET_SYSTEM_RADAR_SETTINGS').API_QUERY)

    ApiHelper(client, 'GET_SYSTEM_RADAR_SETTINGS').API(client, queryParams)
      .then((response) => {
        if (response.status === Constants.CO_API.FAILED) {
          showToastNotification({
            message: 'Failed to get radar settings',
            isSuccess: false,
          })
        } else {
          setState((prevState) => ({
            ...prevState,
            status: response.data.status,
            payment_failed: _.find(RADAR_ACTIONS, { value: response.data.payment_failed }),
            payment_initiated: _.find(RADAR_ACTIONS, { value: response.data.payment_initiated }),
            redzone_countries_payment_initiated: _.find(RADAR_ACTIONS, { value: response.data.redzone_countries_payment_initiated }),
            allow_purchase_without_subscription: response.data.allow_purchase_without_subscription,
          }))
        }
      })
      .catch((error) => {
        showToastNotification({
          message: error.message || 'Failed to get radar settings',
          isSuccess: false,
        })
        console.log(error)
      })
  }, [client, crmUser.id, crmUser.name])

  useEffect(() => {
    getRadarSettings()
  }, [getRadarSettings])

  const onCheckboxValueChange = (e) => {
    const { name } = e.target
    setState((prevState) => ({
      ...prevState,
      [name]: !prevState[name]
    }))
  }

  const onDropdownSelect = (selectedOption, e) => {
    const { name } = e
    setState((prevState) => ({
      ...prevState,
      [name]: selectedOption
    }))
  }

  const onUpdateSettingsClicked = () => {
    const requestBody = {
      settings: {
        status: state.status,
        allow_purchase_without_subscription: state.allow_purchase_without_subscription,
        payment_initiated: state.payment_initiated.value,
        payment_failed: state.payment_failed.value,
        redzone_countries_payment_initiated: state.redzone_countries_payment_initiated.value
      },
      client_secret: Constants.CLIENT_SECRET,
      crm_user_details: JSON.stringify({ name: crmUser.name, user_id: crmUser.id }),
    }

    const body = _.pick(requestBody, ApiHelper(client, 'UDPATE_SYSTEM_RADAR_SETTINGS').API_BODY)

    ApiHelper(client, 'UDPATE_SYSTEM_RADAR_SETTINGS').API(client, body)
      .then((response) => {
        if (response.status === Constants.CO_API.FAILED) {
          showToastNotification({
            message: 'Failed to update radar settings',
            isSuccess: false,
          })
        } else {
          showToastNotification({
            message: 'Radar settings updated successfully',
            isSuccess: true,
          })
        }
      })
      .catch((error) => {
        console.log(error)
        showToastNotification({
          message: error.message || 'Failed to update radar settings',
          isSuccess: false,
        })
      })
  }

  return (
    <div className='mis-wrapper'>
      <h5 className='heading-title'>Radar Settings</h5>
      <p className='heading-subtext'>
        Update Radar Settings
      </p>
      <div className='radar-settings-container mt-4'>
        <div className='radar-settings-checkbox'>
          <CustomCheckOrRadio
            type='checkbox'
            name='status'
            checked={state.status}
            onValueChange={onCheckboxValueChange}
          />
          <span>Global Radar Status</span>
        </div>
        <div className='radar-settings-checkbox'>
          <CustomCheckOrRadio
            type='checkbox'
            name='allow_purchase_without_subscription'
            checked={state.allow_purchase_without_subscription}
            onValueChange={onCheckboxValueChange}
          />
          <span>Allow Addon Purchase Without Active Subscription</span>
        </div>
        <div className='radar-settings-dropdown'>
          <label className='mb-1'>Payment Failure Action:</label>
          <CustomDropdown
            name='payment_failed'
            options={RADAR_ACTIONS}
            placeholder='Select payment failure action'
            value={state.payment_failed}
            onSelectOption={onDropdownSelect}
            searchable={false}
          />
        </div>
        <div className='radar-settings-dropdown'>
          <label className='mb-1'>Payment Initiated Action:</label>
          <CustomDropdown
            name='payment_initiated'
            options={RADAR_ACTIONS}
            placeholder='Select payment initiated action'
            value={state.payment_initiated}
            onSelectOption={onDropdownSelect}
            searchable={false}
          />
        </div>
        <div className='radar-settings-dropdown'>
          <label className='mb-1'>Redzone Countries Payment Initiated Action:</label>
          <CustomDropdown
            name='redzone_countries_payment_initiated'
            options={RADAR_ACTIONS}
            placeholder={'Select redzone payment initiated action'}
            value={state.redzone_countries_payment_initiated}
            onSelectOption={onDropdownSelect}
            searchable={false}
          />
        </div>
        <div className='radar-settings__button'>
          <Button
            onClick={onUpdateSettingsClicked}
            variant='outline-primary'
          >
            Update Settings
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RadarSettings